
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/plan",
      function () {
        return require("private-next-pages/account/plan.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/plan"])
      });
    }
  